
// mui
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'
import Button from '@material-ui/core/Button'
// react
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import styled from 'styled-components'

const OrderedProducts = props => {
    const dispatch = useDispatch()
    const products = props.products

    // 割引後価格
    const discountedPrice = product=>{
        return Math.round( product.price * (1 - product.discount / 100) )
    }
    
    return (
        <List>
            {products.map((product,index) => (
                <ListItemWrapper key={index}>
                    <ListItemAvatar>
                        <ProductImage src={product.images[0].path} alt={'Ordered Product'} />
                        <Actions>
                            <Button color={'primary'} onClick={() => dispatch(push('/product/dp/' + product.id))} >商品ページへ</Button>
                            <Button color={'primary'} onClick={() => dispatch(push('/product/reviewedit/' + product.id))}>レビューを書く</Button>
                        </Actions>
                    </ListItemAvatar>
                    <Details>
                        <div>
                            <ListItemText secondary={product.brand && product.brand.toUpperCase()}/>
                            <ListItemText primary={product.name} secondary={product.variationName} />
                        </div>
                        <div style={{textAlign:'right'}}>
                            <p style={{lineHeight:'1.5rem'}}>{discountedPrice(product) && '¥' + discountedPrice(product).toLocaleString()}</p>
                            {product.discount > 0 && <DiscountTag>{product.discount + '%OFF'}</DiscountTag>}
                            <p style={{lineHeight:'1.5rem', fontSize: '.9rem'}}>{`数量：${product.quantity}`}</p>
                        </div> 
                    </Details>
                </ListItemWrapper>
            ))}
        </List>
    )
}

export default OrderedProducts

const ListItemWrapper = styled(ListItem)`
    height: auto;
    background-color: #333;
`
const ProductImage = styled.img`
    object-fit: contain;
    /* margin: 8px 16px 8px 0; */
    width: 120px;
    height: 120px;
    background-color: #fff;
    margin-right: 20px;
    margin-bottom: 10px;
`
const Details = styled.div`
    flex: 1;
    padding-right: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width:768px){
        padding: 0;
        flex-direction: column;
    }
`
const Actions = styled.div`
    width: 120px;
    display: flex;
    flex-direction: column;
    button {
        padding: 0;
    }
`
const DiscountTag = styled.span`
    width: 80px;
    padding: 2px 4px;
    display: inline;
    text-align: center;
    color: #000;
    background-color: #FCEB04;
    border-radius: 3px;
    font-size: 12px; 
    margin-left: 10px;
`